// The exported copy's file name (D-74, AC-MODE-3): suggested from the original's, cleaned of what file names cannot hold.

/** `name-edited.pdf` after any change of the page (Edit mode), else `name-filled.pdf` (fields, signature, recognised text). */
export function suggestedName(original: string, edited: boolean): string {
  return `${original.replace(/\.pdf$/i, '')}-${edited ? 'edited' : 'filled'}.pdf`;
}

/**
 * The typed name as a file name: characters no file name may hold (Windows, macOS, Linux) become "_", leading dots
 * (hidden files) and trailing dots and spaces (dropped by Windows) go, `.pdf` is added when missing. Undefined when no
 * name is left.
 */
export function cleanName(typed: string): string | undefined {
  const trimmed = typed.trim();
  const ext = /\.pdf$/i.exec(trimmed)?.[0];
  // eslint-disable-next-line no-control-regex
  const stem = trimmed.slice(0, trimmed.length - (ext?.length ?? 0)).replace(/[\\/:*?"<>|\u0000-\u001f\u007f]/g, '_').trim().replace(/^\.+/, '').replace(/[. ]+$/, '');
  return stem ? stem + (ext ?? '.pdf') : undefined;
}
